// extracted by mini-css-extract-plugin
export default {"root":"AW2xlihfDEmnQDc3xRcb","title":"M26C2ssiy94rpgGcWrzA","btn":"kIFXPLGqhu4wH83i2DDq"};